<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-03-07 20:07:49
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-03-07 20:07:50
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "Setting",
};
</script>
